import Swiper from 'swiper';
import {
    Navigation, Pagination, Keyboard, A11y, Thumbs, FreeMode, EffectFade, HashNavigation
}             from 'swiper/modules';

/**
 * Initializes a interview.
 *
 * @param {HTMLElement|Element} el - The HTML element that contains the interview.
 * @return {Array|Boolean} An array containing the mainSwiper and thumbSwiper instances, or false if the HTML element is not provided.
 */

export default function interview(el) {
    if (!el) return false;

    const sliderMain  = el.querySelector('[data-interview="main"] .swiper');
    const sliderThumb = el.querySelector('[data-interview="thumb"] .swiper');
    const next        = el.querySelector('.interview-slide-next');
    const prev        = el.querySelector('.interview-slide-prev');

    const thumbSwiper = new Swiper(sliderThumb, {
        modules             : [FreeMode, A11y],
        loop                : false,
        slidesPerView       : 'auto',
        spaceBetween        : 10,
        freeMode            : false,
        watchSlidesProgress : true,
        observer            : true,
        grabCursor          : true,
        touchRatio          : 1,
        resistance          : true,
        resistanceRatio     : 0
    });

    const mainSwiper = new Swiper(sliderMain, {
        modules             : [Navigation, Thumbs, HashNavigation, EffectFade, Keyboard, A11y],
        loop                : false,
        slidesPerView       : 1,
        spaceBetween        : 0,
        watchSlidesProgress : true,
        threshold           : 10,
        observer            : true,
        grabCursor          : false,
        nested              : true,
        effect              : 'fade',
        fadeEffect          : { crossFade : true },
        hashNavigation      : {
            watchState   : true,
            replaceState : false
        },
        keyboard : {
            enabled        : true,
            onlyInViewport : false
        },
        navigation : {
            nextEl : next,
            prevEl : prev
        },
        thumbs : {
            swiper : thumbSwiper
        },
        on : {
            init() {
                const { hash } = window.location;
                if (hash && hash.startsWith('#slide-')) {
                    setTimeout(() => {
                        const slideIndex = Array.from(this.slides).findIndex((slide) => {
                            const historyValue = slide.getAttribute('data-history');
                            return historyValue && hash === `#${historyValue}`;
                        });

                        if (slideIndex !== -1 && slideIndex !== this.activeIndex) {
                            this.slideTo(slideIndex, 0);
                        }
                    }, 200);
                }
            }
        }
    });

    const breakpoint = window.matchMedia('(min-width: 680px)');

    const updateThumbTouch = () => {
        if (breakpoint.matches) {
            thumbSwiper.allowTouchMove       = true;
            thumbSwiper.params.simulateTouch = true;
            thumbSwiper.update();
        } else {
            thumbSwiper.allowTouchMove       = false;
            thumbSwiper.params.simulateTouch = false;
            thumbSwiper.update();
        }
    };

    try {
        breakpoint.addEventListener('change', updateThumbTouch);
    } catch (e) {
        breakpoint.addListener(updateThumbTouch);
    }

    updateThumbTouch();

    return [mainSwiper, thumbSwiper];
}
